import React from 'react';
import { Navbar } from './components/Navbar';
import { Hero } from './components/Hero';
import { Problem } from './components/Problem';
import { Shift } from './components/Shift';
import { Solution } from './components/Solution';
import { WhyThisWins } from './components/WhyThisWins';
import { UseCases } from './components/UseCases';
import { ProcessFlow } from './components/ProcessFlow';
import { TheEdge } from './components/TheEdge';
import { CTA } from './components/CTA';
import { Footer } from './components/Footer';
export function App() {
  return <div className="min-h-screen bg-primary text-text-muted font-sans selection:bg-accent selection:text-white" data-id="element-0">
      <Navbar data-id="element-1" />
      <main data-id="element-2">
        <Hero data-id="element-3" />
        <Problem data-id="element-4" />
        <Shift data-id="element-5" />
        <Solution data-id="element-6" />
        <WhyThisWins data-id="element-7" />
        <UseCases data-id="element-8" />
        <ProcessFlow data-id="element-9" />
        <TheEdge data-id="element-10" />
        <CTA data-id="element-11" />
      </main>
      <Footer data-id="element-12" />
    </div>;
}